import React, { useEffect, useState } from 'react'
import axios from 'axios';
import CompanyCard from './pages/Company/CompanyCard';
import { useNavigate } from 'react-router';

const CompanyDashboard = () => {

  const [company, setCompany] = useState([]);
  const navigate=useNavigate();

  const fetchCompanyData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}companyDetails/topcompany`);
      setCompany(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  const handleShowMoreCompanies = () => {
    navigate('/companies'); // Navigate to /jobs route
  };

  useEffect(() => {
    fetchCompanyData();
  }, [])

  return (
    <div className="job-area bg py-120">
      <div className="container">
        <div className="row">
          <div
            className="col-lg-6 mx-auto wow fadeInDown"
            data-wow-duration="1s"
            data-wow-delay=".25s"
            style={{
              visibility: "visible",
              animationDuration: "1s",
              animationDelay: "0.25s",
              animationName: "fadeInDown"
            }}
          >
            <div className="site-heading text-center">
              <span className="site-title-tagline">Employers</span>
              <h2 className="site-title">Top Company</h2>
              <p>Work For The Best Companies In The World</p>
            </div>
          </div>
        </div>
        <div className="row">
          {company && company.length > 0 ? (
            company.map((company) => <CompanyCard company={company} key={company.company_id} />)
          ) : (
            <div className="col-12 text-center">
              <p>Loading companies...</p>
            </div>
          )}
        </div>
        <div className="row mt-4">
          <div className="col text-center">
            <button className="theme-btn" onClick={handleShowMoreCompanies}>
              Explore More Companies
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompanyDashboard
